import { render, staticRenderFns } from "./listasprecios-form.vue?vue&type=template&id=ff753478&scoped=true"
import script from "./listasprecios-form.vue?vue&type=script&lang=js"
export * from "./listasprecios-form.vue?vue&type=script&lang=js"
import style0 from "./listasprecios-form.vue?vue&type=style&index=0&id=ff753478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff753478",
  null
  
)

export default component.exports